import { ComponentProps, forwardRef } from "react";
import { Text } from "../TextV2";
import S from "./styled";
import { ICheckBoxProps } from "./type";
import clsx from "clsx";

type Props = Omit<ComponentProps<any>, ""> & ICheckBoxProps;
const CheckBox = forwardRef<HTMLInputElement, Props>(function Checkbox(
	{ description, onClick, errorMessage, customSize, disabled, ...props },
	ref,
) {
	return (
		<div className="w-full">
			<div className="items-emd flex">
				<S.Input
					ref={ref}
					type="checkbox"
					customSize={customSize}
					className={clsx(
						"mr-4 !w-6 !h-6 rounded border-gray-300 bg-transparent text-blue-600 accent-blue-600 focus:ring-2 focus:ring-blue-500 disabled:!cursor-not-allowed disabled:text-gray-500 disabled:accent-gray-500 dark:border-gray-600 dark:bg-transparent dark:accent-blue-500 dark:ring-offset-gray-800 dark:focus:ring-blue-600 dark:disabled:accent-gray-500 disabled:opacity-50",
						disabled ? "disabled:!cursor-not-allowed" : "cursor-pointer",
						props.className,
					)}
					onClick={onClick}
					disabled={disabled}
					{...props}
				/>

				<Text level={5} className="w-full grow">
					{description}
				</Text>
			</div>
			{errorMessage && (
				<div
					style={{
						color: "#EA3F30",
						font: "normal normal bold 14px/18px Lato",
						marginTop: "5px",
					}}
				>
					{errorMessage}
				</div>
			)}
		</div>
	);
});

export default CheckBox;
